import { render, staticRenderFns } from "./MatchInfo.vue?vue&type=template&id=44570b8a&"
import script from "./MatchInfo.vue?vue&type=script&lang=js&"
export * from "./MatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./MatchInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports